import pingbackEvent from 'shared/pingbacks/pingback-networking'
import getLastSearchResponseId from 'shared/util/get-last-search-id'

export function pingback(actions, searchResponseId = '', pageType) {
    const lastSearchResponseId = getLastSearchResponseId()
    return function(dispatch, getState) {
        const searchEvent = {
            event_type: pageType === 'EXPLORE' ? 'GIF_EXPLORE' : 'GIF_SEARCH_OLD',
            response_id: searchResponseId,
            prior_response_id: lastSearchResponseId,
            referrer: document && document.referrer ? document.referrer : null,
            actions,
        }

        return pingbackEvent(searchEvent)(dispatch, getState)
    }
}
